import { render, staticRenderFns } from "./PCView.vue?vue&type=template&id=231c864d&scoped=true"
import script from "./PCView.vue?vue&type=script&lang=js"
export * from "./PCView.vue?vue&type=script&lang=js"
import style0 from "./PCView.vue?vue&type=style&index=0&id=231c864d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231c864d",
  null
  
)

export default component.exports